<template>
  <section class="qrs-typography">
    <pageHeader class="mb--0">
      <h2 class="qrs-header-xl mt--0 mb--0">How do you feel today?</h2>
    </pageHeader>
    <!-- <p>{{jsonData}}</p> -->

    <div v-show="!modalActive">
      <div
        class="govuk-form-group"
        v-for="(item, index) in jsonData"
        v-bind:key="index"
      >
        <div class="question__nav mb--small clearfix mt--16">
          <a
            v-if="sidx >= 1"
            @click="previousStatement"
            class="govuk-back-link mt--0"
            role="button"
            aria-label="go back to the previous screen"
          >
            <strong>Previous</strong>
          </a>
        </div>
        <!-- <p>INDEX: {{index}}</p> -->
        <!-- <p>ITEM: {{ item.data }}</p> -->
        <fieldset
          class="govuk-fieldset"
          v-for="innerItem in item.data"
          v-bind:key="innerItem.id"
        >
          <div v-if="item.data.indexOf(innerItem) == sidx">
            <span class="m-0 mb--16">Question {{ innerItem.no }}</span>
            <legend
              class="govuk-fieldset__legend govuk-fieldset__legend--l mb--0"
            >
              <h3 class="m-0 mb--16">{{ innerItem.title }}</h3>
              <!-- <img class="m-auto d-block" alt="Introduction image" :src="logo" /> -->
            </legend>
            <div class="image__panel mt--16 mb--16">
              <img v-if="innerItem.id == 'Happy'" :src="happyImg" />
              <img v-if="innerItem.id == 'Relaxed'" :src="relaxedImg" />
              <img v-if="innerItem.id == 'Active'" :src="activeImg" />
              <img v-if="innerItem.id == 'Fresh and rested'" :src="freshAndrestedImg"/>
              <img v-if="innerItem.id == 'Day of interests'" :src="dayOfInterestImg"
              />
            </div>
            <p>Please select one face below:</p>
            <div class="govuk-radios">
              <div class="radio__container" style="left: -4px">
                <div class="govuk-radios__item inline-b">
                  <input
                    class="govuk-radios__input"
                    type="radio"
                    :id="innerItem.id + '_' + 'Disagree'"
                    :name="innerItem.id + '_' + 'Disagree'"
                    :checked="innerItem.value == 'Disagree'"
                    v-on:change="innerItem.value = 'Disagree'"
                    @click="
                      toggleChecked(innerItem, innerItem.id + '_' + 'Disagree')
                    "
                  />
                  <label
                    class="govuk-label govuk-radios__label"
                    :for="innerItem.id + '_' + 'Disagree'"
                  >
                    <div
                      v-if="innerItem.checked && innerItem.value == 'Disagree'"
                      class="
                        radio-icon
                        radio-icon__container
                        radio-icon__container--disagree-active
                      "
                    >
                      <i class="fa fa fa-frown fa fa-frown--active"></i>
                    </div>
                    <div v-else class="radio-icon radio-icon__container">
                      <i class="fa fa fa-frown"></i>
                    </div>
                    <span
                      v-if="innerItem.checked && innerItem.value == 'Disagree'"
                      ><strong>Disagree</strong></span
                    >
                    <span v-else>Disagree</span>
                  </label>
                </div>
              </div>
              <div
                class="radio__container"
                style="transform: translate(-50%); left: 50%"
              >
                <div class="govuk-radios__item inline-b">
                  <input 
                    class="govuk-radios__input"
                    type="radio"
                    :id="innerItem.id + '_' + 'Neutral'"
                    :name="innerItem.id + '_' + 'Neutral'"
                    :checked="innerItem.value == 'Neutral'"
                    v-on:change="innerItem.value = 'Neutral'"
                    @click="
                      toggleChecked(innerItem, innerItem.id + '_' + 'Neutral')
                    "
                  />
                  <label
                    class="govuk-label govuk-radios__label"
                    :for="innerItem.id + '_' + 'Neutral'"
                  >
                    <div
                      v-if="innerItem.checked && innerItem.value == 'Neutral'"
                      class="
                        radio-icon
                        radio-icon__container
                        radio-icon__container--neutral-active
                      "
                    >
                      <i class="fa fa fa-meh fa fa-meh--active"></i>
                    </div>
                    <div v-else class="radio-icon radio-icon__container">
                      <i class="fa fa fa-meh"></i>
                    </div>
                    <span
                      v-if="innerItem.checked && innerItem.value == 'Neutral'"
                      ><strong>Neutral</strong></span
                    >
                    <span v-else>Neutral</span>
                  </label>
                </div>
              </div>
              <div class="radio__container" style="right: 4px">
                <div class="govuk-radios__item inline-b">
                  <input
                    class="govuk-radios__input"
                    type="radio"
                    :id="innerItem.id + '_' + 'Agree'"
                    :name="innerItem.id + '_' + 'Agree'"
                    :checked="innerItem.value == 'Agree'"
                    v-on:change="innerItem.value = 'Agree'"
                    @click="
                      toggleChecked(innerItem, innerItem.id + '_' + 'Agree')
                    "
                  />
                  <label
                    class="govuk-label govuk-radios__label"
                    :for="innerItem.id + '_' + 'Agree'"
                  >
                    <div
                      v-if="innerItem.checked && innerItem.value == 'Agree'"
                      class="
                        radio-icon
                        radio-icon__container
                        radio-icon__container--agree-active
                      "
                    >
                      <i class="fa fa fa-smile fa fa-smile--active"></i>
                    </div>
                    <div v-else class="radio-icon radio-icon__container">
                      <i class="fa fa fa-smile"></i>
                    </div>
                    <span v-if="innerItem.checked && innerItem.value == 'Agree'"
                      ><strong>Agree</strong></span
                    >
                    <span v-else>Agree</span>
                  </label>
                </div>
              </div>
            </div>
            <div v-if="sidx == 0 || sidx < 4">
              <button
                name="Continue"
                aria-label="Continue to next question"
                class="govuk-button govuk-button--secondary mt--24"
                @click="nextStatement"
              >
                Continue
                <span class="screen-reader-text"
                  >Continue to next question</span
                >
              </button>
            </div>
            <div v-if="sidx == 4">
              <button
                @click="saveForm"
                name="Save and continue"
                aria-label="Save question answers"
                class="govuk-button govuk-button--secondary mt--24"
              >
                Save and continue
                <span class="screen-reader-text">Save question answers</span>
              </button>
            </div>
          </div>
          <div v-if="item.data.indexOf(innerItem) == sidx">
            <hr class="mb--24 divider" />
            <div class="align-text--center">
              <!-- <button
                class="govuk-button govuk-button--neutral"
                @click="supportClicked(innerItem.id)"
                aria-label="go back to the previous screen"
                >Would you like support???</button> -->

                <button
                class="govuk-button govuk-button--neutral"
                @click="supportClicked()"
                aria-label="go back to the previous screen"
                >Would you like support?</button>
            </div>
          </div>
        </fieldset>
      </div>
    </div>


    <modal v-show="modalActive" :title="modalTitle">
      <ul>
          <li>
            <a href="https://rightdecisions.scot.nhs.uk/aberdeenshire-living-well-with-dementia/aberdeenshire-help-and-support/" target="_blank">Aberdeenshire - Help and support</a>
          </li>
          <li>
            <a href="https://rightdecisions.scot.nhs.uk/angus-living-well-with-dementia/angus-help-and-support/" target="_blank">Angus - Help and support</a>
          </li>
          <li>
            <a href="https://rightdecisions.scot.nhs.uk/inverclyde-living-well-with-dementia/inverclyde-help-and-support/" target="_blank">Inverclyde - Help and support</a>
          </li>
          <li>
            <a href="https://rightdecisions.scot.nhs.uk/living-well-with-dementia-for-everyone/" target="_blank">Living well with dementia - for everyone</a>
          </li>
          <li>
            <a href="https://rightdecisions.scot.nhs.uk/orkney-living-well-with-dementia/orkney-help-and-support/" target="_blank">Orkney - Help and support</a>
          </li>
        </ul>


      <!-- <div v-if="sidx == 0">
        <div class="image__panel mt--16 mb--16">
          <img :src="happyImg" />
        </div>
        <accordion
          :title="informationToRead.title"
          :image="informationImg"
          :content="informationToRead.happy"
        ></accordion>
        <accordion
          :title="activitiesToTry.title"
          :image="activitiesImg"
          :content="activitiesToTry.happy"
        ></accordion>
        <accordion
          :title="communityResources.title"
          :image="communityImg"
          :content="communityResources.happy"
        ></accordion>
        <accordion
          :title="moreSupport.title"
          :image="moreSupportImg"
          :content="moreSupport.happy"
        ></accordion>
      </div>
      <div v-if="sidx == 1">
        <div class="image__panel mt--16 mb--16">
          <img :src="relaxedImg" />
        </div>
        <accordion
          :title="informationToRead.title"
          :image="informationImg"
          :content="informationToRead.relaxed"
        ></accordion>
        <accordion
          :title="activitiesToTry.title"
          :image="activitiesImg"
          :content="activitiesToTry.relaxed"
        ></accordion>
        <accordion
          :title="communityResources.title"
          :image="communityImg"
          :content="communityResources.relaxed"
        ></accordion>
        <accordion
          :title="moreSupport.title"
          :image="moreSupportImg"
          :content="moreSupport.relaxed"
        ></accordion>
      </div>
      <div v-if="sidx == 2">
        <div class="image__panel mt--16 mb--16">
          <img :src="activeImg" />
        </div>
        <accordion
          :title="informationToRead.title"
          :image="informationImg"
          :content="informationToRead.active"
        ></accordion>
        <accordion
          :title="activitiesToTry.title"
          :image="activitiesImg"
          :content="activitiesToTry.active"
        ></accordion>
        <accordion
          :title="communityResources.title"
          :image="communityImg"
          :content="communityResources.active"
        ></accordion>
        <accordion
          :title="moreSupport.title"
          :image="moreSupportImg"
          :content="moreSupport.active"
        ></accordion>
      </div>
      <div v-if="sidx == 3">
        <div class="image__panel mt--16 mb--16">
          <img :src="freshAndrestedImg" />
        </div>
        <accordion
          :title="informationToRead.title"
          :image="informationImg"
          :content="informationToRead.rested"
        ></accordion>
        <accordion
          :title="activitiesToTry.title"
          :image="activitiesImg"
          :content="activitiesToTry.rested"
        ></accordion>
        <accordion
          :title="communityResources.title"
          :image="communityImg"
          :content="communityResources.rested"
        ></accordion>
        <accordion
          :title="moreSupport.title"
          :image="moreSupportImg"
          :content="moreSupport.rested"
        ></accordion>
      </div>
      <div v-if="sidx == 4">
        <div class="image__panel mt--16 mb--16">
          <img :src="dayOfInterestImg" />
        </div>
        <accordion
          :title="informationToRead.title"
          :image="informationImg"
          :content="informationToRead.interests"
        ></accordion>
        <accordion
          :title="activitiesToTry.title"
          :image="activitiesImg"
          :content="activitiesToTry.interests"
        ></accordion>
        <accordion
          :title="communityResources.title"
          :image="communityImg"
          :content="communityResources.interests"
        ></accordion>
        <accordion
          :title="moreSupport.title"
          :image="moreSupportImg"
          :content="moreSupport.interests"
        ></accordion>
      </div> -->
    </modal>
  </section>
</template>

<script>
import informationToRead from "../controls/data/informationToRead.js";
import activitiesToTry from "../controls/data/activitiesToTry.js";
import communityResources from "../controls/data/communityResources.js";
import moreSupport from "../controls/data/moreSupport.js";

export default {
  name: "statements",
  data() {
    return {
      jsonData: this.$parent.jsonData,
      sidx: 0,
      next_idx: 0,
      prev_idx: 0,
      continueBtnDisabled: true,
      happyImg: this.$parent.happyImg,
      relaxedImg: this.$parent.relaxedImg,
      activeImg: this.$parent.activeImg,
      freshAndrestedImg: this.$parent.freshAndrestedImg,
      dayOfInterestImg: this.$parent.dayOfInterestImg,
      informationImg: this.$parent.informationImg,
      activitiesImg: this.$parent.activitiesImg,
      communityImg: this.$parent.communityImg,
      moreSupportImg: this.$parent.moreSupportImg,
      informationToRead: informationToRead,
      activitiesToTry: activitiesToTry,
      communityResources: communityResources,
      moreSupport: moreSupport,
      modalActive: false,
      modalTitle: "Would you like support?",
    };
  },
  mounted() {},
  methods: {
    // supportClicked(statementId) {
    //   if (statementId === 'Happy') {
    //     this.modalTitle = "Support to feel more happy and hopeful";
    //   } else if (statementId === 'Relaxed') {
    //     this.modalTitle = "Support to feel more calm and relaxed";
    //   } else if (statementId === 'Active') {
    //     this.modalTitle = "Support to feel more active and energetic";
    //   } else if (statementId === 'Fresh and rested') {
    //     this.modalTitle = "Support to sleep well";
    //   } else if (statementId === 'Day of interests') {
    //     this.modalTitle = "Support to do things that interest me";
    //   }
    //   this.modalActive = true;
    // },

    supportClicked() {
      this.modalTitle = "Help and support";
      this.modalActive = true;
    },

    toggleChecked(item, id) {
      item.checked = 1;
      console.log(id);
    },

    nextStatement() {
      console.log("next clicked");
      let _data = this.jsonData.statements.data;
      if (this.sidx == 0 || this.sidx < _data.length) {
        this.sidx++;
      }
    },
    previousStatement() {
      console.log("previous clicked");
      let _data = this.jsonData.statements.data;
      if (this.sidx >= 1 && this.sidx < _data.length) {
        this.sidx--;
      }
    },
    saveForm() {
      console.log("save this form");
      let answeredItems = [];

      for (var i in this.jsonData) {
        this.jsonData[i].data.forEach(function (item) {
          if (item.value.length > 0) {
            answeredItems.push(item.value);
            console.log(answeredItems);
          } else if (item.value == '') {
            console.log("question has been skipped" + " " + item.id);
            item.value = "Not answered";
          }
        });
      }

      if (answeredItems.length > 0) {
        this.$parent.updateDiary(this.$parent.statementAnswers, this.jsonData);
        this.$parent.viewDiary = true;
        this.$parent.goTo(this.$EntryAdded);
      } else {
        console.log("no questions answered");
        this.$parent.goTo(this.$NoEntriesAdded);
      }
      this.$parent.clearJsonData(this.jsonData);
      this.$parent.accordionActive = false;

      // console.log(this.$parent.statementAnswers.statements.data);
      // this.$parent.goTo(this.$EntryAdded);
    },
  },
};
</script>